import { Injectable } from '@angular/core';
import { BaseDTO } from '../../utils/BaseDTO';
import { AddDriverForm } from '../models/AddDriverForm';
import { UploadImageResponse } from '../../utils/models/UploadImageResponse';
import { VehicleResponse } from '../../api/models/responses/VehicleResponse';
import { DriverRequest } from '../../api/models/requests/DriverRequest';
import { LicenseRequest } from '../../api/models/requests/LicenseRequest';

//Al llegar a este punto del programa ya se deben haber realizado las solicitudes de creacion
//relacionadas al driver
type RequestsData = {
  driver: AddDriverForm;
  vehicle: VehicleResponse;
  driverPhoto: UploadImageResponse;
  licensesPhotos: UploadImageResponse[];
};

@Injectable({
  providedIn: 'root',
})
export class DriverRequestDTO extends BaseDTO<RequestsData, DriverRequest> {
  override mapTo(data: RequestsData): DriverRequest {
    const licences: LicenseRequest[] = [];
    for (let i = 0; i < data.driver.licenses.length; i++) {
      licences.push({
        ...data.driver.licenses[i],
        image: data.licensesPhotos[i].data,
      });
    }

    const driver: DriverRequest = {
      licences,
      vehicle: data.vehicle._id,
      photo: data.driverPhoto.data,
      birthday: data.driver.personal.birthday,
      ci: data.driver.personal.dni,
    };

    if (data.driver.personal.selectedUser) {
      driver.userId = data.driver.personal.selectedUser.id;
    } else {
      driver.user = {
        firstname: data.driver.personal.name,
        lastname: data.driver.personal.lastname,
        email: data.driver.personal.email,
        phone: data.driver.personal.phone,
        password: data.driver.credentials.password,
        roles: ['driver'],
      };
    }

    return driver;
  }
}
